import React from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import {
   Facebook,
   Instagram,
   //  MailOutline,
   //  Phone,
   //  Room,
   Twitter,
} from "@mui/icons-material"
import {
   FACEBOOK_URL,
   INSTAGRAM_URL,
   TWITTER_URL,
   TIKTOK_URL,
} from "../../data"
// Components
import TikTokIcon from "../TikTokIcon"
// Styles
import {
   Container,
   Left,
   Logo,
   Description,
   SocialContainer,
   SocialIcon,
   Center,
   Title,
   List,
   ListItem,
   //  Right,
   //  ContactItem,
   //  ContactIcon,
   StyledLink,
} from "./Footer.styles"
import { useTheme } from "styled-components"

const Footer = () => {
   const theme = useTheme()
   const { t } = useTranslation()
   return (
      <Container id="footer">
         <Left>
            <Logo>LOSERS MAGNIFIQUES</Logo>
            <Description>{t("footer.text.t1")}</Description>
            <SocialContainer>
               <Link
                  to={FACEBOOK_URL}
                  target="_blank"
                  style={{ targetNew: "tab" }}
               >
                  <SocialIcon>
                     <Facebook />
                  </SocialIcon>
               </Link>
               <Link
                  to={INSTAGRAM_URL}
                  target="_blank"
                  style={{ targetNew: "tab" }}
               >
                  <SocialIcon>
                     <Instagram />
                  </SocialIcon>
               </Link>
               <Link
                  to={TWITTER_URL}
                  target="_blank"
                  style={{ targetNew: "tab" }}
               >
                  <SocialIcon>
                     <Twitter />
                  </SocialIcon>
               </Link>
               <Link
                  to={TIKTOK_URL}
                  target="_blank"
                  style={{ targetNew: "tab" }}
               >
                  <SocialIcon>
                     <TikTokIcon color={theme.secondary} />
                  </SocialIcon>
               </Link>
            </SocialContainer>
         </Left>
         <Center>
            <Title>{t("footer.title.t1")}</Title>
            <List>
               <ListItem>
                  <StyledLink to="/">{t("footer.menu.m1")}</StyledLink>
               </ListItem>
               <ListItem>
                  <StyledLink to="/products">{t("footer.menu.m2")}</StyledLink>
               </ListItem>
               <ListItem>
                  <StyledLink to="/cart">{t("footer.menu.m3")}</StyledLink>
               </ListItem>
               <ListItem>
                  <StyledLink to="/account">{t("footer.menu.m4")}</StyledLink>
               </ListItem>
               <ListItem>
                  <StyledLink to="/legal">{t("footer.menu.m5")}</StyledLink>
               </ListItem>
               <ListItem>
                  <StyledLink to="/contact">{t("footer.menu.m6")}</StyledLink>
               </ListItem>
            </List>
         </Center>
         {/*
         <Right>
            <Title>{t("footer.title.t2")}</Title>
            <ContactItem>
               <ContactIcon>
                  <Room />
               </ContactIcon>
               700 Les Roches, 39270, Alièze, France
            </ContactItem>       
            <ContactItem>
               <ContactIcon>
                  <Phone />
               </ContactIcon>
               + 33 456 789 012
            </ContactItem>
            <ContactItem>
               <ContactIcon>
                  <MailOutline />
               </ContactIcon>
               contact@losersmagnifiques.com
            </ContactItem>
         </Right>
         */}
      </Container>
   )
}

export default Footer
